import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FormArray } from '@angular/forms/src/model';

import { FormService } from "../Services/form.service";

import { QuestionBase } from './question-base';

@Component({
    selector: 'app-question',
    templateUrl: './dynamic-form-question.component.html',
    styleUrls: ['./enquete.component.css'],
})
export class DynamicFormQuestionComponent {
    @Input() question: QuestionBase<any>;
    @Input() form: FormGroup;
    get isValid() { return this.form.controls[this.question.key].valid; }

    otherForm = false;
    other = '';

    constructor(
        private formService: FormService,
      ) {}

    onCheckChanged(value, isChecked: boolean) {
        if (isChecked) {
            this.question.value.push(value);
        } else {
            let index = this.question.value.findIndex(elm => elm == value);
            this.question.value.splice(index, 1);
        }
    }

    onRadioOther(value) {
        this.question.value = value;
        this.other = value;
    }
    onOther(isChecked: boolean) {
        this.otherForm = !this.otherForm;
        if(isChecked) {
            this.question.value.push(this.other);
        }else{
            let index = this.question.value.findIndex(elm => elm == this.other);
            this.question.value.splice(index, 1);
        }
    }

    onCheckOther(value) {
        //this.question.value['other'] = value;
        //前回の入力分を削除
        let index = this.question.value.findIndex(elm => elm == this.other);
        this.question.value.splice(index, 1);
        
        this.question.value.push(value);
        this.other = value;
    }



    /**
 * 郵便番号から住所を取得
 * @param zip 
 */
    searchZip(zip: string) {
        if (zip.length == 7) {
            this.formService.searchZip(zip).then(addr => {
                this.setZip(addr);
            });
        }
    }

    /**
     * 取得した住所をフォームにセット
     * @param addr 
     */
    setZip(addr) {
        if (addr !== undefined) {            
            this.form.controls[this.question.key].patchValue({
                    pref: this.question.options[ addr['0']].value,
                    city: addr['1'],
                    street: addr['2'],
            });
        }
    }
}